const dataValidations = ({ type, value, title, required, min, max }) => {
  if (required && !value) return 'Filed is required';
  else {
    let error = '';
    const fieldName = title || 'Field';
    switch (type) {
      case 'number':
        if (value < min || value > max) {
          error = `Min: ${min} Max: ${max}`;
        }
        break;
      case 'email':
        if (!value.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
          error = 'Invalid email';
        }
        break;
      case 'text':
      default:
        if (value.length < min || value.length > max) {
          error = `${fieldName} must be at least ${min} characters`;
        }
    }
    return error;
  }
};

export default dataValidations;
